<template>
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="importModel">
            {{ $translate('catalog_view') }}
          </b-button>
        </div>
        <div class="column is-4 is-offset-1">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="suggDuna">
            {{ $translate('sugg_duna') }}
          </b-button>
        </div>
        <b-tabs position class="blocks fulllength" horizontal>
          <b-tab-item :label="$translate('tomaio') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_tomaio_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <tomaio
                  ref="tomaio"
                  :mod.sync="mod"
                  :orderbool="true"
                  :module="'modular'"
                  :disabledbool="disabledbool || uniqueComposition"
                  :availablepell.sync="filteredPell"
                  :availablerip.sync="filteredRip"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item v-if="showDrilledFodera || showVelcro" :label="$translate('fodera_allacciatura') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('fodera_allacciatura') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>

              <div class="column is-6">
                <b-field :label="$translate('drilled_fodera') | capitalize" horizontal v-if="showDrilledFodera">
                  <b-checkbox v-model="order.mod.hasDrilledFodera" />
                </b-field>

                <b-field
                  v-if="showVelcro"
                  horizontal
                  :label="$translate('velcri_length') | capitalize"
                  :message="errors.first('velcri_length')"
                  :type="{ 'is-danger': errors.has('velcri_length') }"
                >
                  <b-input
                    v-model="mod.velcri_length"
                    placeholder="misure mm"
                    :expanded="false"
                    :disabled="disabledbool"
                    v-validate="'between:0,999|integer'"
                    name="velcri_length"
                    type="number"
                  />
                </b-field>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('suola') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_suola_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <suola
                  ref="suola"
                  :order.sync="order"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="!mod.image || mod.catalogchoose || disabledbool"
                  :disabledboolcolor.sync="mod.color_bool"
                  :availablesoles.sync="filteredSoles"
                  :availablebatt.sync="availablebatt"
                  :availablefogge="filteredFogge"
                  :is-simplified.sync="isSimplified"
                  @onUpdateSole="setSole"
                />
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
        <b-modal
          :active.sync="isComponentModalActive"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          custom-class="modular-catalog-modal"
        >
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ $translate('catalog_view') }} {{ $translate(catalogType) }}
                {{ $translate(shoeType) }}
              </p>
              <b-input v-model="filterModel" />
            </header>
            <section class="modal-card-body">
              <div class="columns is-multiline is-mobile">
                <div v-for="model in filteredModels" :key="model.id" class="column is-half">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img :src="model.image" alt="Placeholder image" />
                      </figure>
                    </div>
                    <div class="card-content" style="height: 96px">
                      <div class="content has-text-centered">
                        {{ model.name }}
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        class="card-footer-item"
                        @click="
                          tempmodel = model
                          importBasicData()
                        "
                        >{{ $translate('import') | capitalize }}</a
                      >
                    </footer>
                  </div>
                </div>
              </div>

              <!--
          <b-field :label="$translate('model') | capitalize" horizontal>
            <b-select
              name="model"
              v-model="tempmodel"
              :placeholder="$translate('placeholder_model')"
            >
              <option v-for="model in models" :key="model.id" :value="model">
                {{ model.name }}
              </option>
            </b-select>
              </b-field>-->
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="isComponentModalActive = false">
                {{ $translate('close') | capitalize }}
              </button>
            </footer>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import materialTools from '../../../helpers/mixins/materialTools'
import { compareModelPosition } from '@/helpers/mixins/modelTools'
//import modelTools from '../../../helpers/mixins/modelTools'
/*import modelTailored from '@/helpers/mixins/modelTools'*/
import tomaio from '../../Mod/components/tomaio'
import suola from '../../Orders/components/suola-orders'
import imageModel from './ImageModel'
//import allestimento from "../../Mod/components/allestimento";

export default {
  name: 'OrderModel',
  components: {
    //allestimento: allestimento,
    suola: suola,
    tomaio: tomaio,
    imageModel: imageModel,
  },
  mixins: [materialTools],
  props: {
    mod: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availablepell: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablerip: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablebatt: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableguard: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablesott: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablesoles: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablefogge: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableallestimenti: {
      type: Array,
      default: () => {
        return []
      },
    },
    shoeType: {
      type: String,
      default: null,
    },
    catalogType: {
      type: String,
      default: null,
    },
    disabledbool: Boolean,
    catalogModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSaveDisabled: Boolean,
    order: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSimplified: Boolean,
    config: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    shapeFilter: {
      type: String,
      required: false,
      default: () => {
        return ''
      },
    },
    hasSecondaryPrev: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    seasontag: {
      type: String,
      required: false,
      default: null,
    },
  },

  inject: ['$validator'],
  data() {
    return {
      models: [],
      isComponentModalActive: false,
      uploadFile: null,
      uploadFileBool: false,
      tempmodel: {},
      web_catalog: [],
      filterModel: '',
      filteredSoles: [],
      filteredFogge: [],
      filteredPell: [],
      filteredRip: [],
      showDrilledFodera: false,
      showVelcro: false,
      uniqueComposition: false,
    }
  },
  computed: {
    filteredModels() {
      let models = this.models.filter(model => model.name.toLowerCase().includes(this.filterModel.toLowerCase()))
      if (this.shapeFilter) models = models.filter(model => model.shapes.includes(this.shapeFilter))
      if (this.hasSecondaryPrev) {
        models = models.filter(model => model.hasSecondaryPrev)
      } else {
        models = models.filter(model => !model.hasSecondaryPrev)
      }
      if (this.seasontag)
        models = models.filter(model => model.seasontags === this.seasontag || model.seasontags === 'no_seas')
      return models.sort(compareModelPosition)
    },
  },
  watch: {
    shoeType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
    catalogType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
    seasontag: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
  },
  methods: {
    refreshCatalog() {
      if (this.catalogModel !== undefined) {
        this.$db
          .collection(this.config.models)
          .where('catalogType', '==', this.catalogType)
          .where('shoeType', '==', this.shoeType)
          .where('draft', '==', false)
          .get()
          .then(docs => {
            this.models = []
            docs.forEach(doc => {
              let mode = doc.data()
              mode.id = doc.id
              if (this.catalogModel[mode.id]) {
                this.models.push(mode)
              }
            })
            this.$forceUpdate()
          })
      }
    },
    async updateAfterload() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
      this.showDrilledFodera = this.order.mod.hasDrilledFodera
      this.showVelcro = this.order.mod.hasVelcro

      if (this.mod.uniqueComposition) {
        this.filteredPell = {
          1: this.availablepell,
          2: this.availablepell,
          3: this.availablepell,
          4: this.availablepell,
          5: this.availablepell,
        }
        this.filteredRip = { 1: this.availablerip, 2: this.availablerip, 3: this.availablerip, 4: this.availablerip }
        this.uniqueComposition = true
      } else {
        let pellList = {}
        let ripList = {}
        for (let key in this.mod.possiblePel) {
          const pells = this.mod.possiblePel[key]
          const pellsData = this.availablepell.filter(pell => pells.includes(pell.id))
          pellList = { ...pellList, [key]: pellsData }
        }
        for (let key in this.mod.possibleRip) {
          const rips = this.mod.possibleRip[key]
          const ripsData = this.availablerip.filter(pell => rips.includes(pell.id))
          ripList = { ...ripList, [key]: ripsData }
        }

        this.filteredPell = pellList
        this.filteredRip = ripList
        this.uniqueComposition = false
      }

      // this.filteredPell = this.availablepell.filter(pell => this.mod.possiblePel.includes(pell.id))
      // this.filteredRip = this.availablerip.filter(rip => this.mod.possibleRip.includes(rip.id))

      this.setModelSoleData(this.mod)
      // let filteredSoles = this.availablesoles.filter(sole => {
      //   return this.mod.soles.includes(sole.id)
      // })
      // if (filteredSoles) {
      //   filteredSoles = filteredSoles.filter(sole => {
      //     return sole.shapes.some(shape => shape.type === this.order.shoeType)
      //   })
      // }
      // const fogge = filteredSoles.map(sole => {
      //   return sole.foggia
      // })
      // this.filteredSoles = [...filteredSoles]
      // this.filteredFogge = Array.from(new Map(fogge.map(foggia => [foggia.id, foggia])).values())
      // filteredSoles = filteredSoles.map(sole => ({
      //   ...sole,
      //   shapes: sole.shapes.filter(shape => shape.type === this.order.shoeType),
      // }))

      await this.$refs.tomaio.updateAfterload()
      await this.$refs.suola.updateAfterLoad()
    },
    importImage() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('warning_import_model'),
        type: 'is-warning',
      })

      var tempmop = this.mod
      tempmop.image = this.tempmodel.image
      this.mod.catalogchoose = false
      this.disabledbool = false
      this.$emit('update:mod', tempmop)
      this.isComponentModalActive = false
    },
    async importBasicData() {
      this.showDrilledFodera = this.tempmodel.hasDrilledFodera
      this.showVelcro = this.tempmodel.hasVelcro
      if (!this.tempmodel.uniqueComposition) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('warning_import_model'),
          type: 'is-warning',
        })
      }
      let tempMod = this.mod
      this.setBasicModelTomaioCount(this.tempmodel, tempMod)
      tempMod.image = this.tempmodel.image
      tempMod.name = this.tempmodel.name
      tempMod.id = this.tempmodel.id
      tempMod.color_bool = false
      tempMod.sole_default = this.tempmodel.sole_default
      tempMod.soles = this.tempmodel.soles
      tempMod.fogge = this.tempmodel.fogge
      tempMod.sizes = this.tempmodel.sizes
      tempMod.description = this.tempmodel.description
      tempMod.possiblePel = this.tempmodel.possiblePel
      tempMod.possibleRip = this.tempmodel.possibleRip
      tempMod.hasVelcro = this.tempmodel.hasVelcro
      tempMod.hasDrilledFodera = this.tempmodel.hasDrilledFodera
      tempMod.hasForteAlto = this.tempmodel.hasForteAlto
      tempMod.puncture = !!this.tempmodel.puncture
      tempMod.uniqueComposition = !!this.tempmodel.uniqueComposition
      tempMod.hasSecondaryPrev = !!this.tempmodel.hasSecondaryPrev
      this.order.typecontr_sx = 'calc'
      this.order.typecontr_dx = 'calc'
      this.mod.catalogchoose = false
      this.mod.custom = false
      this.disabledbool = false

      if (this.tempmodel.uniqueComposition) {
        this.filteredPell = {
          1: this.availablepell,
          2: this.availablepell,
          3: this.availablepell,
          4: this.availablepell,
          5: this.availablepell,
        }
        this.filteredRip = { 1: this.availablerip, 2: this.availablerip, 3: this.availablerip, 4: this.availablerip }
        this.uniqueComposition = true
        await this.forceDuna()
      } else {
        let pellList = {}
        let ripList = {}
        for (let key in this.tempmodel.possiblePel) {
          const pells = this.tempmodel.possiblePel[key]
          const pellsData = this.availablepell.filter(pell => pells.includes(pell.id))
          pellList = { ...pellList, [key]: pellsData }
        }
        for (let key in this.tempmodel.possibleRip) {
          const rips = this.tempmodel.possibleRip[key]
          const ripsData = this.availablerip.filter(pell => rips.includes(pell.id))
          ripList = { ...ripList, [key]: ripsData }
        }

        this.filteredPell = pellList
        this.filteredRip = ripList
        this.uniqueComposition = false
      }

      // this.filteredPell = this.availablepell.filter(pell => this.tempmodel.possiblePel.includes(pell.id))
      // this.filteredRip = this.availablerip.filter(rip => this.tempmodel.possibleRip.includes(rip.id))

      this.setModelSoleData(this.tempmodel)
      // let filteredSoles = this.availablesoles.filter(sole => {
      //   return this.tempmodel.soles.includes(sole.id)
      // })
      //
      // if (filteredSoles) {
      //   filteredSoles = filteredSoles.filter(sole => {
      //     return sole.shapes.some(shape => shape.type === this.order.shoeType)
      //   })
      // }
      //
      // const fogge = filteredSoles.map(sole => {
      //   return sole.foggia
      // })
      //
      // this.filteredSoles = [...filteredSoles]
      // this.filteredFogge = Array.from(new Map(fogge.map(foggia => [foggia.id, foggia])).values())
      this.$emit('update:mod', tempMod)
      this.order.tiporinfsott_sx = this.tempmodel.hasSecondaryPrev ? 'sottopiede4' : 'sottopiede3'
      this.order.tiporinfsott_dx = this.tempmodel.hasSecondaryPrev ? 'sottopiede4' : 'sottopiede3'
      this.$refs.suola.updateSole({})
      this.isComponentModalActive = false
    },
    suggDuna() {
      if (this.mod.image) {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('alert_model'),
          cancelText: this.$translate('undo'),
          confirmText: this.$translate('confirm'),
          onConfirm: async () => {
            if (!this.tempmodel.uniqueComposition) {
              let pellList = {}
              let ripList = {}
              for (let key in this.tempmodel.possiblePel) {
                const pells = this.tempmodel.possiblePel[key]
                const pellsData = this.availablepell.filter(pell => pells.includes(pell.id))
                pellList = { ...pellList, [key]: pellsData }
              }
              for (let key in this.tempmodel.possibleRip) {
                const rips = this.tempmodel.possibleRip[key]
                const ripsData = this.availablerip.filter(pell => rips.includes(pell.id))
                ripList = { ...ripList, [key]: ripsData }
              }

              this.filteredPell = pellList
              this.filteredRip = ripList
              this.uniqueComposition = false
            } else {
              this.filteredPell = {
                1: this.availablepell,
                2: this.availablepell,
                3: this.availablepell,
                4: this.availablepell,
                5: this.availablepell,
              }
              this.filteredRip = {
                1: this.availablerip,
                2: this.availablerip,
                3: this.availablerip,
                4: this.availablerip,
              }
              this.uniqueComposition = true
            }

            const cloneDeep = require('clone-deep')
            await this.$emit('update:mod', cloneDeep(this.tempmodel))
            let temp = cloneDeep(this.mod)
            for (let element in temp) {
              if (temp[element] === undefined) {
                //console.log(element);
                temp[element] = null
              }
            }
            this.mod.sole = this.availablesoles.find(sole => sole.id === this.mod.sole_default)
            temp.sole = this.mod.sole
            this.$emit('update:mod', cloneDeep(temp))
            this.$refs.suola.updateAfterLoad()
          },
        })
      } else {
        this.$buefy.toast.open(this.$translate('error_sugg'))
      }
    },
    async forceDuna() {
      if (this.mod.image) {
        let pellList = {
          1: this.availablepell,
          2: this.availablepell,
          3: this.availablepell,
          4: this.availablepell,
          5: this.availablepell,
        }
        let ripList = { 1: this.availablerip, 2: this.availablerip, 3: this.availablerip, 4: this.availablerip }
        // for (let key in this.tempmodel.possiblePel) {
        //   const pells = this.tempmodel.possiblePel[key]
        //   const pellsData = this.availablepell.filter(pell => pells.includes(pell.id))
        //   pellList = { ...pellList, [key]: pellsData }
        // }
        // for (let key in this.tempmodel.possibleRip) {
        //   const rips = this.tempmodel.possibleRip[key]
        //   const ripsData = this.availablerip.filter(pell => rips.includes(pell.id))
        //   ripList = { ...ripList, [key]: ripsData }
        // }

        this.filteredPell = pellList
        this.filteredRip = ripList
        const cloneDeep = require('clone-deep')
        await this.$emit('update:mod', cloneDeep(this.tempmodel))
        let temp = cloneDeep(this.mod)
        for (let element in temp) {
          if (temp[element] === undefined) {
            //console.log(element);
            temp[element] = null
          }
        }
        this.mod.sole = this.availablesoles.find(sole => sole.id === this.mod.sole_default)
        temp.sole = this.mod.sole
        this.$emit('update:mod', cloneDeep(temp))
        this.$refs.suola.updateAfterLoad()
      } else {
        this.$buefy.toast.open(this.$translate('error_sugg'))
      }
    },
    importModel() {
      if (this.shoeType != null && this.catalogType != null) {
        this.isComponentModalActive = true
      } else {
        //this.$buefy.toast.open(`Specifica il catalogo e il tipo di calzatura`);
        this.$buefy.toast.open(this.$translate('error_catalog'))
      }
    },
    deliveryUpdated() {
      this.$forceUpdate()
    },

    setBasicModelTomaioCount(modelReference, modelToUpdate) {
      const pellCount = Object.keys(modelReference || {})
        .filter(k => /^pell\d+mat$/.test(k))
        .filter(k => modelReference[k] !== null).length
      const ripCount = Object.keys(modelReference || {})
        .filter(k => /^rip\d+mat$/.test(k))
        .filter(k => modelReference[k] !== null).length
      const { maxPel, maxRip } = this.$moduleConfiguration['modular']
      for (let i = 1; i <= maxPel; i++) {
        if (i <= pellCount) {
          this.$set(modelToUpdate, `pell${i}mat`, '')
          this.$set(modelToUpdate, `pell${i}var`, null)
          this.$set(modelToUpdate, `pell${i}allestimento`, null)
        } else {
          this.$delete(modelToUpdate, `pell${i}mat`)
          this.$delete(modelToUpdate, `pell${i}var`)
          this.$delete(modelToUpdate, `pell${i}allestimento`)
        }
      }
      for (let i = 1; i <= maxRip; i++) {
        if (i <= ripCount) {
          this.$set(modelToUpdate, `rip${i}mat`, '')
          this.$set(modelToUpdate, `rip${i}var`, null)
          this.$set(modelToUpdate, `rip${i}allestimento`, null)
        } else {
          this.$delete(modelToUpdate, `rip${i}mat`)
          this.$delete(modelToUpdate, `rip${i}var`)
          this.$delete(modelToUpdate, `rip${i}allestimento`)
        }
      }
      this.$refs.tomaio.updateAfterload()
    },

    setModelSoleData(model) {
      let filteredSoles = this.availablesoles.filter(sole => {
        return model.soles.includes(sole.id)
      })
      if (filteredSoles) {
        filteredSoles = filteredSoles.filter(sole => {
          return sole.shapes.some(shape => shape.type === this.order.shoeType)
        })
      }
      const foggeIds = [...new Set(filteredSoles.map(sole => sole.foggia.id))]
      this.filteredSoles = [...filteredSoles]
      this.filteredFogge = this.availablefogge.filter(foggia => foggeIds.includes(foggia.id))
    },

    setSole(sole) {
      this.mod.sole = sole
      this.$emit('update:mod', this.mod)
    },
    resetTabs() {
      this.showVelcro = false
      this.showDrilledFodera = false
      this.$refs.suola.resetAsImage()
    },
  },
}
</script>
<style>
.opaque {
  opacity: 0.5;
}
.modular-catalog-modal .modal-card {
  width: 960px;
  max-width: 90vw;
}
</style>
